import { useState } from "react";
import { PhoneCall, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { getRememberedEmail } from "@/lib/memberEmail";

/** Members-only same-day callback request, opened from the welcome bar. */
export function CallbackRequest({ onClose }) {
  const [form, setForm] = useState({ phone: "", when: "", note: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const r = await api.post("/memberships/callback", { email: getRememberedEmail(), ...form });
      toast.success(`Requested — David will call you ${r.data.when}`);
      onClose();
    } catch (err) { toast.error(err?.response?.data?.detail || "Couldn't send — call 310-422-0669"); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="border-b border-[#FFD600]/30 bg-[#0B1120] text-sm" data-testid="callback-form">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex flex-col sm:flex-row sm:items-end gap-2">
        <div className="font-semibold text-[#FFD600] flex items-center gap-2 sm:pb-2"><PhoneCall className="w-4 h-4" /> Priority callback</div>
        <input required type="tel" placeholder="Phone to call" className="dg-input text-sm sm:w-44" value={form.phone} onChange={set("phone")} data-testid="callback-phone" autoComplete="tel" />
        <input type="text" placeholder="Best time (e.g. after 3pm)" className="dg-input text-sm sm:w-48" value={form.when} onChange={set("when")} data-testid="callback-when" />
        <input type="text" placeholder="What's going on? (optional)" className="dg-input text-sm flex-1" value={form.note} onChange={set("note")} data-testid="callback-note" />
        <div className="flex gap-2">
          <button type="submit" disabled={busy || form.phone.trim().length < 7} className="dg-btn-primary rounded-full px-4 py-2 text-sm flex items-center gap-1 disabled:opacity-50" data-testid="callback-submit">
            {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <PhoneCall className="w-3 h-3" />} Request callback
          </button>
          <button type="button" onClick={onClose} className="dg-btn-ghost rounded-full px-3 py-2 text-sm" aria-label="Close" data-testid="callback-close"><X className="w-4 h-4" /></button>
        </div>
      </div>
    </form>
  );
}
